export default 'Close dialog';